const csvTemplate = `sku
AU.SC-SPMW1001
AU.SC-SPDCCF1
AU.SC-TPRYDCTPS20ALL1
AU.SC-TPRYDLAERPALL1
CRS.SC-UMISSP501
CRS.SC-UMISSPM501001
CRS.SC-CSSUPM701
CRS.SC-CSSUPM30ALL1
CRS.SC-BSDUPALL1`;

export default csvTemplate;
